import React from "react";
import { Button as MUIButton } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { SxProps, Theme } from "@mui/system";

interface CustomButtonProps {
    label?: string;
    children?: React.ReactNode;
    variant?: "contained" | "outlined" | "text";
    color?: "primary" | "secondary" | "error" | "info" | "success" | "warning";
    onClick?: () => void;
    startIcon?: React.ReactNode;
    endIcon?: React.ReactNode;
    fullWidth?: boolean;
    disabled?: boolean;
    loading?: boolean;
    className?: string;
    size?: "small" | "medium" | "large";
    sx?: SxProps<Theme>;
    type?: "button" | "submit" | "reset";
}

const Button: React.FC<CustomButtonProps> = ({
    label,
    children,
    variant = "contained",
    color = "primary",
    onClick,
    startIcon,
    endIcon,
    fullWidth = false,
    disabled = false,
    loading = false,
    size = "medium",
    sx,
    type = "button",
    className = "",
}) => {
    return (
        <MUIButton
            type={type}
            variant={variant}
            color={color}
            onClick={onClick}
            startIcon={!loading ? startIcon : undefined}
            endIcon={!loading ? endIcon : undefined}
            fullWidth={fullWidth}
            disabled={disabled || loading}
            size={size}
            sx={sx}
            className={className}
        >
            {loading ? <CircularProgress size={20} color="inherit" /> : children || label}
        </MUIButton>
    );
};

export default Button;
